export default class DadosCertificadoModel {
    constructor(public cert: String,
                public codSerialHexaInvert: String,
                public codigoCertificado: String,
                public codigoSerial: String,
                public cpfResponsavel: number,
                public inscricao: string,
                public issuer: String,
                public razaoSocial: String,
                public responsavel: String,
                public tpInscricao: number,
                public caepf: boolean,
                public boTkn: boolean){}
}
